import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'zip_code_protection-retailer_exclusivity_post_commitment_info-click';

/**
 * Triggered when user click the post commitment exclusivity info badge on different surface area
 */
export function trackZipCodeProtectionRetailerExclusivityPostCommitmentInfoClick(
  agreement_token: string,
  origin2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { agreement_token, origin2 },
  });
}
